/**
 * accesoService.js — endpoints públicos de acceso (sin sesión):
 * invitación de condóminos y restablecer contraseña.
 *
 * Van con fetch directo y no con apiFetch: apiFetch agrega el token y, ante un
 * 401, cierra la sesión y manda al login — justo lo que no hay que hacer en una
 * pantalla a la que se llega sin haber iniciado sesión.
 */
const BASE_URL = process.env.REACT_APP_API_URL ?? "";

async function llamar(path, { method = "GET", body } = {}) {
  const lang = localStorage.getItem("lang") || "es";
  const res = await fetch(`${BASE_URL}${path}`, {
    method,
    headers: { "Content-Type": "application/json", "Accept-Language": lang },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (res.status === 429) {
    const err = new Error("Demasiados intentos. Esperá unos minutos y volvé a probar.");
    err.status = 429;
    err.data = {};
    throw err;
  }
  if (!res.ok) {
    const err = new Error(data?.detail || "No se pudo completar la solicitud.");
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export const getInvitacion = (token) =>
  llamar(`/api/core/auth/invitacion/${encodeURIComponent(token)}/`);

export const aceptarInvitacion = (token, body) =>
  llamar(`/api/core/auth/invitacion/${encodeURIComponent(token)}/`, { method: "POST", body });

export const solicitarReset = (identificador) =>
  llamar("/api/core/auth/password-reset/", { method: "POST", body: { identificador } });

export const validarReset = (uid, token) =>
  llamar("/api/core/auth/password-reset/validar/", { method: "POST", body: { uid, token } });

export const confirmarReset = (uid, token, password) =>
  llamar("/api/core/auth/password-reset/confirmar/", { method: "POST", body: { uid, token, password } });
